import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IWarehouse } from "../iWarehouse";
import  { WarehouseEditorView } from "./warehouseEditor-view"

export class WarehouseEditorViewModel extends ViewModel implements IWarehouse,IPopup{
    constructor(parentViewModel: ViewModel,updater : IServerUpdater) {
        super(parentViewModel);
        this.districtSelector = new DistrictSelector(this);
        this.districtSelector.onSelectionChanged = x=>this.districtId=x.id;
        this._updater = updater;
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseEditorView();
    }
    public getTypeId(): string {
        return "VM-339F8E06-7C42-4E7E-A436-4AEC69CCAB1F"
    }


    cloneTo(warehouse: IWarehouse) {
        warehouse.id = this.id;
        warehouse.name = this.name;
        warehouse.districtId = this.districtSelector.selectedItem.id;
        warehouse.districtName = this.districtSelector.selectedItem.title
    }

    closePopup(result: any) {
    }

    private _updater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set districtId(v: string) { 
        this._districtId = v; 
        this.districtSelector.selectById(v);
    } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector;} private _districtSelector: DistrictSelector;
        
    back(){
        this.closePopup(null);
    }

    async save(){
        let verificationResult = this.verify();
        if(verificationResult.length>0){
            this.messageBoxConfirmWarning(verificationResult.join('\n'),'خطا در ثبت انبار');
            return;
        }else{
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess('انبار با موفقیت ثبت شد.','ثبت موفق');
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning('خطا در ثبت انبار','خطا در عملیات');
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام مشخص نشده است.')
        }
        if(this.districtSelector.selectedItem==null){
            result.push('شعبه مشخص نشده است.')
        }
        return result;
    }
}

export interface IServerUpdater{
    execute(warehouse:IWarehouse):Promise<any>;
}

export class WarehouseInserter implements IServerUpdater{
    async execute(warehouse: IWarehouse): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/InventoryManipulationServices/CreateWarehouse',{
                Name:warehouse.name,
                DistrictId:warehouse.districtId,
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Warheouse";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class WarehouseUpdater implements IServerUpdater{
    async execute(warehouse: IWarehouse): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/InventoryManipulationServices/UpdateWarehouse',{
                Id:warehouse.id,
                NewName:warehouse.name,
            });
            if(result.IsSuccessful==false){
                throw "Error Saving Warehouse";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}
